// Shared types for the Flowchart designer + viewer.
// Mirror the backend schema enforced by
// strategy_management.serializers._validate_flowchart_payload.

export type FlowchartNodeType = 'start' | 'step' | 'decision' | 'end';

export const FLOWCHART_NODE_TYPES: FlowchartNodeType[] = [
  'start', 'step', 'decision', 'end',
];

export interface FlowchartNode {
  id: string;
  type: FlowchartNodeType;
  label: string;
  position: { x: number; y: number };
}

export interface FlowchartEdge {
  id: string;
  source: string;
  target: string;
  label?: string;
  // Optional handle ids (e.g., 'left' | 'right' | 'top' | 'bottom').
  // Auto-generated RTL diagrams set these so React Flow connects via
  // the right-side source handle of one node to the left-side target
  // of the next — producing horizontal arrows that match the manual.
  sourceHandle?: string;
  targetHandle?: string;
}

export interface FlowchartData {
  version: string;
  nodes: FlowchartNode[];
  edges: FlowchartEdge[];
}

export const EMPTY_FLOWCHART: FlowchartData = {
  version: '1.0',
  nodes: [],
  edges: [],
};

// Visual presets per node type. Kept here (not in the node components)
// so the viewer's SVG fallback can use the same palette as the React
// Flow designer without re-importing it from each shape file.
export const NODE_VISUAL_PRESETS: Record<FlowchartNodeType, {
  bg: string;
  border: string;
  text: string;
  width: number;
  height: number;
  shape: 'pill' | 'rect' | 'diamond';
}> = {
  start: {
    bg:     '#DCFCE7',  // soft green
    border: '#16A34A',
    text:   '#14532D',
    width:  140, height: 56, shape: 'pill',
  },
  step: {
    bg:     '#DBEAFE',  // soft blue
    border: '#2563EB',
    text:   '#1E3A8A',
    width:  160, height: 64, shape: 'rect',
  },
  decision: {
    bg:     '#FEF3C7',  // soft amber
    border: '#D97706',
    text:   '#78350F',
    width:  150, height: 90, shape: 'diamond',
  },
  end: {
    bg:     '#FEE2E2',  // soft red
    border: '#DC2626',
    text:   '#7F1D1D',
    width:  140, height: 56, shape: 'pill',
  },
};
